var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('el-upload',{attrs:{"data":_vm.dataAuth,"accept":"application/pdf","limit":1000,"action":_vm.baseUrl,"show-file-list":false,"on-success":_vm.handleAvatarSuccess,"before-upload":_vm.beforeAvatarUpload}},[_c('el-button',{attrs:{"size":"mini","loading":_vm.loading,"type":"primary"}},[_vm._v("点击上传")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }